import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisIdeasRoute: InvariantJiraRoute = {
	name: 'polaris-ideas',
	path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
	query: ['selectedIssue?', 'issueViewLayout?', 'jpdWrapped?'],
	exact: true,
};
